import { AnlageassistentContextProvider } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentContextProvider';
import { AnlageassistentFormProvider } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { DesktopPage } from '@/domain/mitarbeiter/pages/anlageassistent/DesktopPage';
import { MobilePage } from '@/domain/mitarbeiter/pages/anlageassistent/MobilePage';
import { LoadingPage } from '@/pages';
import { Suspense } from 'react';

export function PageWrapper() {
  return (
    <Suspense fallback={<LoadingPage />}>
      <AnlageassistentFormProvider>
        <AnlageassistentContextProvider>
          <div className="md:flex flex-col gap-8 w-screen h-dvh hidden">
            <DesktopPage />
          </div>
          <div className="block md:hidden">
            <MobilePage />
          </div>
        </AnlageassistentContextProvider>
      </AnlageassistentFormProvider>
    </Suspense>
  );
}
